<template>
  <div>
    <b-modal id="staffPosition" title="Staff Position" size="lg">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Staff Position
        </div>
      </template>

      <div class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <table>

          <tr>
            <th></th>
            <th style="text-align: center;">Position</th>
            <!-- <th>Hands-On Fee</th> -->
          </tr>

          <tr class="form-group" v-for="(staff, index) in selectedStaffs" :key="'staff_' + index">
            <td>
              <label class="form-label">{{ staff['name'] }}</label>
            </td>
            <td>
              <multiselect
                v-model="position[staff['id']]"
                :options="positions"
                :searchable="false"
                :show-labels="false"
                @input="(e) => positionChange(staff['id'], e)"
                openDirection="below">
                <template slot="option" slot-scope="{ option }">{{ option }}</template>
              </multiselect>
            </td>
            <td>
              <!-- <input
                class="form-control"
                placeholder="Hands-On Fee"
                v-model="fee[staff['id']]"
                type="number" /> -->
            </td>
          </tr>

        </table>

      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>
<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "staffPosition",
  data() {
    return {
      showLoading: false,
      outlets: [],
      positions: ['Senior', 'Junior', 'Assistant'],
      staffs: [],
      selectedStaffs: [],

      selectedOutlet: {},
      data: {},
      position: {},
      fee: {},
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('staffPosition')
      this.loadStaff()
    },

    onOutletChange() {
      // Object.assign(this.data, {})
      this.data = {}
      this.postion = {}
      this.basic = {}

      this.selectedStaffs = []
      for (let staff of this.staffs) {
        if (this.selectedOutlet.id === staff['outletID']) {
          this.selectedStaffs.push({ id: staff['staffID'], name: staff['name'] + ' - ' + staff['mobile'], outletID: staff['outletID'] })

          this.data[staff['staffID']] = {
            position: '',
            fee: '',
          }
          this.postion[staff['staffID']] = ''
          this.basic[staff['staffID']] = ''
        }
      }

      console.log(this.postion)

      this.loadCommission()
    },

    loadStaff() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://staff.tunai.io/business/staff',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.staffs = response.data.staffs
          this.onOutletChange()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadCommission() {
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_EnchantedSibling_fixedCommission_staff_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_EnchantedSibling_fixedCommission_staff_setting`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          response.data = response.data || {}
          // this.data = response.data
          for (let temp in response.data) {
            // this.data[temp] = response.data[temp]
            // this.basic[temp] = response.data[temp]['basic']
            this.position[temp] = response.data[temp]['position']
            this.fee[temp] = response.data[temp]['fee']
          }

          this.$forceUpdate()
        })
        .catch((err) => {
          console.log(err)
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    positionChange(staffID, e) {
      this.position[staffID] = e
      this.$forceUpdate()
    },

    save() {
      this.showLoading = true

      let request = {}
      // for (let key in this.data) {
      //   request[key] = this.data[key]
      // }
      // for (let key in this.basic) {
      //   request[key] = request[key] || {}
      //   request[key]['basic'] = this.basic[key]
      // }
      for (let key in this.position) {
        request[key] = request[key] || {}
        request[key]['position'] = this.position[key]
      }
      for (let key in this.fee) {
        request[key] = request[key] || {}
        request[key]['fee'] = this.fee[key]
      }

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_EnchantedSibling_fixedCommission_staff_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_EnchantedSibling_fixedCommission_staff_setting`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('staffPosition')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>
<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}
</style>